import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions, KlarnaActions } from 'actions';
import Constants from 'Constants';
import ItemDetails from 'components/Store/ItemDetails';

class KlarnaCheckoutForm extends Component {
  static propTypes = {
    children: PropTypes.node,
    type: PropTypes.number,
    store: PropTypes.string,
    id: PropTypes.number,
    cart: PropTypes.array
  };

  componentDidMount() {
    StoreOverviewActions.startPayment(
      Constants.paymentProviders.KLARNACHECKOUT,
      null,
      null,
      null
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.discountCode !== nextProps.discountCode) {
      StoreOverviewActions.startPayment(
        Constants.paymentProviders.KLARNACHECKOUT,
        null,
        null,
        null
      );
    }
    if (this.props.snippet !== nextProps.snippet) {
      const { snippet } = nextProps;
      const node = this.refs.klarnaShizzle;
      node.innerHTML = snippet;
      const klarnaCode = node.getElementsByTagName('script')[0].text; //node.children[0].children[0].text;
      const script = document.createElement('script');
      script.type = 'text/javascript';
      try {
        script.appendChild(document.createTextNode(klarnaCode));
      } catch (e) {
        script.text = klarnaCode;
      }
      node.appendChild(script);
    }
  }

  render() {
    const { cart, ...other } = this.props;
    const [item] = cart;
    return (
      <div>
        <ItemDetails {...item} />
        <div ref="klarnaShizzle" />
      </div>
    );
  }
}

export default KlarnaCheckoutForm;



// WEBPACK FOOTER //
// ./src/js/components/Store/KlarnaCheckoutForm.js